import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TestimonialSlider() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (!items.length) return;
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return null;
  const t = items[idx];

  return (
    <div className="relative max-w-3xl mx-auto" data-testid="testimonial-slider">
      <AnimatePresence mode="wait">
        <motion.div
          key={t.id}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          transition={{ duration: 0.5 }}
          className="text-center px-4"
        >
          <div className="flex justify-center gap-1 mb-5">
            {Array.from({ length: t.rating }).map((_, i) => (
              <Star key={i} className="w-5 h-5 text-yellow-brand" fill="#F4BB29" />
            ))}
          </div>
          <p className="text-2xl md:text-3xl text-white/90 leading-snug font-light balanced">
            <span className="font-script text-yellow-brand text-4xl md:text-5xl mr-1">“</span>
            {t.text}
            <span className="font-script text-yellow-brand text-4xl md:text-5xl ml-1">”</span>
          </p>
          <div className="mt-6 text-yellow-brand font-script text-3xl">{t.name}</div>
          <div className="text-white/50 text-sm uppercase tracking-widest">{t.location}</div>
        </motion.div>
      </AnimatePresence>

      <div className="flex justify-center gap-3 mt-10">
        <button
          aria-label="Previous"
          data-testid="testimonial-prev"
          onClick={() => setIdx((i) => (i - 1 + items.length) % items.length)}
          className="w-11 h-11 rounded-full glass flex items-center justify-center text-white hover:text-yellow-brand transition-colors"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          aria-label="Next"
          data-testid="testimonial-next"
          onClick={() => setIdx((i) => (i + 1) % items.length)}
          className="w-11 h-11 rounded-full glass flex items-center justify-center text-white hover:text-yellow-brand transition-colors"
        >
          <ChevronRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
